var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group_person"},_vm._l((_vm.headList),function(item,index){return (_vm.headList)?_c('div',{key:index},[_c('img',{attrs:{"src":item,"alt":""}})]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }